var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityWarningCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning_circle_fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.627 0 12-5.373 12-12v0c0-6.627-5.373-12-12-12v0zM17.066 22.316c-0.278 0.285-0.666 0.462-1.095 0.462-0.844 0-1.528-0.684-1.528-1.528s0.684-1.528 1.528-1.528c0.844 0 1.528 0.684 1.528 1.528v0c0 0.010 0 0.021 0 0.032 0 0.405-0.166 0.771-0.434 1.034l-0 0zM17 17.25h-2l-0.753-6.022c-0.009-0.066-0.014-0.141-0.014-0.218 0-0.972 0.788-1.76 1.76-1.76h0.013c0.972 0 1.76 0.788 1.76 1.76 0 0.077-0.005 0.153-0.015 0.227l0.001-0.009z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityWarningCircleFill);
export default __webpack_public_path__ + "static/media/unity_warning_circle_fill.50dff66d18e848f5041939caffa60b0f.svg";
export { ForwardRef as ReactComponent };